import { fetchAuthAPI, putAuthAPI, postAuthAPI, deleteAuthAPI } from './client';

/**
 * Get admin email list (Admin only)
 */
export const getAdminEmails = async (token: string): Promise<string[]> => {
  return fetchAuthAPI<string[]>('/settings/admin-emails');
};

/**
 * Update admin email list (Admin only)
 */
export const updateAdminEmails = async (emails: string[], token: string): Promise<string[]> => {
  return putAuthAPI<string[]>('/settings/admin-emails', emails);
};

/**
 * Add admin email (Admin only)
 */
export const addAdminEmail = async (email: string, token: string): Promise<string[]> => {
  return postAuthAPI<string[]>('/settings/admin-emails', { email });
};

/**
 * Remove admin email (Admin only)
 */
export const removeAdminEmail = async (email: string, token: string): Promise<string[]> => {
  return deleteAuthAPI<string[]>(`/settings/admin-emails/${encodeURIComponent(email)}`);
};
